type MembershipChannel = {
  id: string;
};

type MembershipRecord = {
  channel_id: string;
  joined_at?: string | null;
};

export type ChannelMembershipState = {
  is_joined: boolean;
  joined_at: string | null;
};

export const applyChannelMembershipState = <
  TChannel extends MembershipChannel,
  TMembership extends MembershipRecord,
>(
  channels: TChannel[],
  memberships: TMembership[],
): Array<TChannel & ChannelMembershipState> => {
  const membershipByChannel = new Map(
    memberships
      .filter((membership) => membership.channel_id)
      .map((membership) => [membership.channel_id, membership]),
  );

  return channels.map((channel) => {
    const membership = membershipByChannel.get(channel.id);

    return {
      ...channel,
      is_joined: Boolean(membership),
      joined_at: membership?.joined_at ?? null,
    };
  });
};

export const splitChannelsByMembership = <
  TChannel extends {
    is_joined?: boolean | null;
  },
>(
  channels: TChannel[],
) => ({
  joinedChannels: channels.filter((channel) => channel.is_joined),
  discoverChannels: channels.filter((channel) => !channel.is_joined),
});

export const getJoinedChannels = <
  TChannel extends {
    is_joined?: boolean | null;
  },
>(
  channels: TChannel[],
) => channels.filter((channel) => channel.is_joined);
